module.exports = __webpack_public_path__ + "img/tablet-neck-3_544x18.49cf2286.png";